import type { Config } from './types';

export const Staging: Partial<Config> = {
  GEM_HOST: 'https://beta.gem.com',
  LEVER_HOST: 'https://hire.sandbox.lever.co',
  SEGMENT_WRITE_KEY: 'pCEpDAvGTOwT6E5LZgJLOmMIAJ5vLnyM',
};
